var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-animation"},[_c('img',{attrs:{"src":"/animation/no-data-animation.gif","alt":"No data animation"}})])
}]

export { render, staticRenderFns }